// Default API configurations
const DEFAULT_CONFIG = {
  BASE_URL: "https://api.btime.io/assistant",
  ENDPOINTS: {
    QUERY: "/query",
  },
  AUTH_TOKEN: null,
  WORKSPACE: null,
};

// Configuration that can be overwritten by the user
let API_CONFIG = { ...DEFAULT_CONFIG };

// Function to update configurations
export const updateConfig = (newConfig) => {
  API_CONFIG = {
    ...API_CONFIG,
    ...newConfig,
    ENDPOINTS: {
      ...API_CONFIG.ENDPOINTS,
      ...(newConfig.ENDPOINTS || {}),
    },
  };
};

// Função para configurar o token de autenticação
export const setAuthToken = (token) => {
  API_CONFIG.AUTH_TOKEN = token;
};

// Função para configurar o workspace
export const setWorkspace = (workspace) => {
  API_CONFIG.WORKSPACE = workspace;
};

// Function to get current configurations
export const getConfig = () => {
  return API_CONFIG;
};

export { API_CONFIG };
